import React from "react";
import { useRef, useEffect } from "react";
import Header from "./Sections/Header";
import Slider from "./Sections/Slider";
import About from "./Sections/About";
import Services from "./Sections/Services";
import Staff from "./Sections/Staff";
import Footer from "./Sections/Footer";
import "./Style/theme1.scss"

const ClientSiteTheme1 = (props) => {

     useEffect(() => {
    document.title = props.site.siteTitle;
  }, []);
  
   return (
    <div data-theme={props.site.themeId === 1 ? "one": props.site.themeId === 2 ? "two" : "one"}>
      <Header site={props.site}/>
      <Slider site={props.site} />
      {props.site.aboutUsPageEnabled ?
      <section id="about" className="section about-section about-left light-bg" style={{zIndex:"-1"}}>
        <div className="" style={{marginRight:"auto"}}>
          <About site={props.site}/>
        </div>
      </section>
      :
      <>
      </>
      }
      {props.site.servicePageEnabled ?
      <section id="services" className="section services-section gray-bg">
        <div className="container">
          <Services site={props.site}/>
        </div>
      </section>
      :
      <>
      </>
      }
      {props.site.staffPageEnabled ?
      <section id="staff" className="section light-bg">
        <div className="container">
          <Staff site={props.site}/>
        </div>
      </section>
      :
      <>
      </>
      }
      <footer className="footer-site white">
        <div className="container">
          <Footer site={props.site}/>
        </div>
      </footer>
    </div>
   );
};

export default ClientSiteTheme1;
